// extracted by mini-css-extract-plugin
export default {"overviewLocation":"overviewLocation__ZWVjN","reviewsLink":"reviewsLink__ZTZjY","yelpAverageRating":"yelpAverageRating__ZmIwY","titleLinks":"titleLinks__ZWQ5Y"};